import styled from "styled-components"
import color from "../../assets/css/colors"

export const Message = styled.span`
    position: absolute;
    color: ${color.red};
    bottom: 6px;
    left: 0;
    font-size: 12px;
`